module.exports = __webpack_public_path__ + "static/img/2-Angular momentum@2x.bcbdbde3.png";